/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import 'slick-carousel/slick/slick.scss'

// We need jQuery for all the rails-ujs (jquery-ujs) stuff
import $ from 'jquery'

// custom libs
import AbLoadHTMLTemplate from '$lib/html_load_template'

/* global window */
import Root from '../src/pages/frontend/root'

// see above import of `$`: We need jQuery as `window.jQuery` or `window.$`
// for all the rails-ujs stuff (in require('jquery-ujs')),
// e.g. for having `method: :delete` on `link_to` work correctly
window.jQuery = $
window.$ = $

// extending jQuery
new AbLoadHTMLTemplate()

require('jquery-ujs')
require('slick-carousel')

class Ausbildung {
  constructor() {
    new Root()
  }
}

$(() => {
  window.ausbildung = new Ausbildung()
})
